import React, { useState, useEffect } from 'react';
import './Navigation.css';
import logo from '../assets/logo.png'; // Make sure to add your logo in the assets folder

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => setIsOpen(false);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="logo">
          <img src={logo} alt="Cire Étoilée" className="logo-image" />
        </div>

        <div className={`burger-menu ${isOpen ? 'active' : ''}`} onClick={toggleMenu} aria-label="Menu" role="button" aria-expanded={isOpen}>
          <span className="burger-bar"></span>
          <span className="burger-bar"></span>
          <span className="burger-bar"></span>
        </div>

        <div className={`nav-overlay ${isOpen ? 'active' : ''}`} onClick={closeMenu}></div>

        <div className={`nav-links ${isOpen ? 'active' : ''}`}>
          <a href="#about" onClick={closeMenu}>Accueil</a>
          <a href="#products" onClick={closeMenu}>Nos Produits</a>
          <a href="#fragrance" onClick={closeMenu}>Nos Senteurs</a>
          <a href="#testimonials" onClick={closeMenu}>Avis client</a>
          <a href="#contact" onClick={closeMenu}>Contact</a>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
